import { DEFAULT_PRO_SUBSCRIBE_OFFER_CODE } from '@components/pages/NewsletterIndexLanding/NewsletterCard/interfaces';
import { Offers } from '@contexts/AppContext';
import { newsletter_list_path, subscribe_path, upgrade_subscription_path } from '@routes';

export const handleSubscriberRedirect = ({
  canSubscribeToNewsletter,
  isPro,
  afterSignUpUrl,
  offers,
  isCurrentlySubscriber,
  isProSubscriber,
  redirectTo,
}: {
  canSubscribeToNewsletter: boolean;
  isPro: boolean;
  afterSignUpUrl?: string;
  offers?: Offers;
  isCurrentlySubscriber: boolean;
  isProSubscriber: boolean;
  redirectTo?: string;
}) => {
  if (canSubscribeToNewsletter) {
    return afterSignUpUrl || newsletter_list_path();
  }

  const subscribePath = (offer?: string) =>
    subscribe_path({
      offer,
      ...(redirectTo && { redirect_to: redirectTo }),
    });

  if (!isPro) {
    return afterSignUpUrl ?? subscribePath(offers?.subscribe);
  }

  if (isCurrentlySubscriber && !isProSubscriber) {
    return upgrade_subscription_path(offers?.upgrade ? { offer: offers.upgrade } : undefined);
  }

  return afterSignUpUrl ?? subscribePath(offers?.subscribe ?? DEFAULT_PRO_SUBSCRIBE_OFFER_CODE);
};
